<template>
    <div class="integration-form">
        <b-card>
            <h2>{{ id ? $t('hotel_group.edit') : $t('hotel_group.add') }}</h2>

            <b-form @submit.prevent="handleSubmit" @reset="resetForm" novalidate>
                <!-- Group Name -->
                <div class="mb-3 text-left">
                    <label class="mb-1" for="name">{{ $t('hotel_group.name') }}</label>
                    <b-form-input v-model="formFields.name" :state="formErrors.has('name') ? false : null" @input="removeError('name')"
                        :placeholder="$t('hotel_group.name')" />
                    <b-form-invalid-feedback :state="!formErrors.has('name')">
                        {{ formErrors.first('name') }}
                    </b-form-invalid-feedback>
                </div>

                <!-- Description -->
                <div class="mb-3 text-left">
                    <label class="mb-1" for="description">{{ $t('hotel_group.description') }}</label>
                    <b-form-textarea v-model="formFields.description" :placeholder="$t('hotel_group.description')"
                        rows="4" />
                    <b-form-invalid-feedback :state="!formErrors.has('description')">
                        {{ formErrors.first('description') }}
                    </b-form-invalid-feedback>
                </div>

                <!-- Submit & Cancel -->
                <div class="d-flex gap-2 mt-4">
                    <b-button type="submit" variant="primary" :disabled="isSubmitting">
                        <b-spinner small v-if="isSubmitting" class="mr-1" />
                        {{ $t('action.submit') }}
                    </b-button>
                    <b-button variant="secondary" @click="cancel">
                        {{ $t('action.cancel') }}
                    </b-button>
                </div>
            </b-form>
        </b-card>
    </div>
</template>

<script>
import { request } from '@/Util/Request';
import Error from '@/Util/Error';

const FORM_STATE = {
    name: '',
    description: '',
};

export default {
    name: 'HotelGroupForm',
    data() {
        return {
            id: null,
            formFields: { ...FORM_STATE },
            formErrors: new Error({}),
            isSubmitting: false,
        };
    },
    mounted() {
        this.id = this.$route.params.id || null;
        if (this.id) this.loadHotelGroup();
    },
    methods: {
        
        async removeError(target) {
            if (typeof target === 'object') {
                for (let i = 0; i < target.length; i++) {
                    this.formErrors.remove(target[i]);
                }
            } else {
                this.formErrors.remove(target);
            }
        },
        async loadHotelGroup() {
            try {
                const response = await request({ method: 'get', url: `public/hotel-groups/${this.id}` });
                const data = response.data;
                this.formFields = { ...FORM_STATE, ...data };
            } catch (e) {
                console.error('Failed to load hotel group', e);
            }
        },
        async handleSubmit() {
            try {
                this.formErrors = new Error({});
                this.isSubmitting = true;
                const method = this.id ? 'put' : 'post';
                const url = this.id ? `/hotel-groups/${this.id}` : '/hotel-groups';

                await request({ method, url, data: this.formFields });

                this.$bvToast.toast(
                    this.$t(this.id ? 'hotel_group.updated_successfully' : 'hotel_group.created_successfully'),
                    {
                        title: this.$t('common.success'),
                        variant: 'success',
                        solid: true,
                    }
                );
                setTimeout(() => {
                    this.$router.push({ name: "HotelGroupList" });
                }, 1000);
            } catch (error) {
                if (error.request?.status === 422) {
                    this.formErrors = new Error(JSON.parse(error.request.responseText).errors);
                } else {
                    this.$bvToast.toast(this.$t('common.something_went_wrong'), {
                        title: this.$t('common.error'),
                        variant: 'danger',
                        solid: true,
                    });
                }
            } finally {
                this.isSubmitting = false;
            }
        },
        cancel() {
            this.$router.back();
        },
        resetForm() {
            this.formFields = { ...FORM_STATE };
            this.formErrors = new Error({});
        },
    },
};
</script>
